export default __webpack_public_path__ + "static/media/lsqa.9348ec4c.png";